import React                                      from 'react';
import PropTypes                                  from 'prop-types';
import PerfectScrollbar                           from 'perfect-scrollbar';
import Flux                                       from '../../flux/Flux';
import ReloadHelper                               from '../../utils/ReloadHelper';
import Translations                               from '../../utils/Translations';
import UrlBuilder                                 from '../../utils/UrlBuilder';
import VideoRecommendationsGrid                   from './VideoRecommendationsGrid';
import Category                                   from '../Video/Jumbotron/Category';
import withVideoRecommendationsByActorIdOrAlbumId from '../HigherOrderComponents/ActorProfileVideos/withVideoRecommendationsByActorIdOrAlbumId';
import withVideoRecommendationsFromVideoStation   from '../HigherOrderComponents/ActorProfileVideos/withVideoRecommendationsFromVideoStation';

let ps = {};
class VideoRecommendationsSimilarVideos extends React.Component {
	constructor(props) {
		super(props);
		this.recommendationsBlockRef = null;
		this.state                   = {
			isCinematicMode:     false,
			componentIsVertical: Flux.Browser.getWindowSize().width > 1180,
		};

		this.goToAllVideosPage          = this.goToAllVideosPage.bind(this);
		this.isRecommendedEmpty         = this.isRecommendedEmpty.bind(this);
		this.setRecommendationsBlockRef = this.setRecommendationsBlockRef.bind(this);
		this.onWindowResize             = this.onWindowResize.bind(this);
		this.onCinematicModeChange      = this.onCinematicModeChange.bind(this);
	}

	componentDidMount() {
		Flux.Browser.addWindowResizeListener(this.onWindowResize);
		Flux.Gallery.addCurrentVideoCinematicModeListener(this.onCinematicModeChange);
	}

	componentWillUnmount() {
		Flux.Browser.removeWindowResizeListener(this.onWindowResize);
	}

	onWindowResize() {
		this.setState({componentIsVertical: (Flux.Browser.getWindowSize().width > 1180 && !this.state.isCinematicMode)});
		this.props.perfectScrollbarOn && ps.update(this.recommendationsBlockRef);
	}

	onCinematicModeChange(enabled) {
		this.setState({
			isCinematicMode:     enabled,
			componentIsVertical: (Flux.Browser.getWindowSize().width > 1180 && !enabled),
		}, () => {
			if (this.props.perfectScrollbarOn) {
				ps.destroy(this.recommendationsBlockRef);
				if (!enabled) {
					ps = new PerfectScrollbar(this.recommendationsBlockRef, {
                        wheelPropagation: true
                    });
				}
			}
		});
	}

	/**
	 * @param element
	 */
	setRecommendationsBlockRef(element) {
		if (element && this.props.perfectScrollbarOn && this.state.componentIsVertical) {
			this.recommendationsBlockRef = element;
			ps = new PerfectScrollbar(element, {
                suppressScrollX: true,
                wheelPropagation: true
            });
		}
	}

	/**
	 * @return {boolean}
	 */
	isRecommendedEmpty() {
		const {videos, recommendationsLoadingState} = this.props;
		return !recommendationsLoadingState && (!Array.isArray(videos) || (videos.length < 1));
	}

	/**
	 * @param {Event} e
	 */
	goToAllVideosPage(e) {
		const uri = this.isRecommendedEmpty() ? UrlBuilder.buildVideoIndexRoute() : UrlBuilder.buildActorProfileVideosUrl(this.props.actorName);
		if(this.props.navigateTo) {
			this.props.navigateTo(uri, e);
		} else {
			ReloadHelper.reload(uri, e);
		}
	}

	render() {
		const {actorId, actorName, jumbotronCategories, videos} = this.props;
		let content                                             = null;
		if (this.isRecommendedEmpty()) {
			content = <div className="grid-2 grid-2--with-no-margins">{jumbotronCategories.map((c, k) => <Category {...c} key={k} />)}</div>;
		} else {
			content = (
				<VideoRecommendationsGrid sameActor={true}
				                          actorId={actorId}
				                          actorName={actorName}
				                          displayTooFewItemsTile={false}
										  navigateTo={this.props.navigateTo}
				                          videos={videos}
				                          isSimilarVideos={true}
				                          displayCount={this.state.componentIsVertical ? null : (this.props.videos ? (this.props.videos.length - this.props.videos.length % 4) : null)}
										  slider={this.props.slider}
				/>
			);
		}
		const componentIsVerticalStyle = this.state.componentIsVertical ? {maxHeight: '617px'} : {};
		return (
			<section className="profile-video-details--similar-videos">
				<div className="profile-video-details--similar-videos-title">
					<h2 className="profile-video-details--similar-videos-title-text">
						{Translations.get('MediaPanelVideoAlbumSimilar')}
					</h2>
				</div>
				<div className="profile-video-details--similar-videos-column" ref={this.setRecommendationsBlockRef} style={componentIsVerticalStyle}>
					{content}
				</div>
				<div className="profile-video-details--similar-videos-footer">
					<span className="profile-video-details--similar-videos-footer-button vxbutton -btn-color-transparent -btn-border-outline"
					      onClick={this.goToAllVideosPage}
					>
						{Translations.get('AllVideosActorVideos')}
					</span>
				</div>
			</section>
		);
	}
}

VideoRecommendationsSimilarVideos.propTypes = {
	actorId:                     PropTypes.number.isRequired,
	actorName:                   PropTypes.string.isRequired,
	albumId:                     PropTypes.number.isRequired,
	displayTooFewItemsTile:      PropTypes.bool,
	navigateTo:                  PropTypes.func,
	orientationIsVertical:       PropTypes.bool,
	perfectScrollbarOn:          PropTypes.bool,
	videos:                      PropTypes.array,
	recommendationsLoadingState: PropTypes.bool,
	jumbotronCategories:         PropTypes.array,
	slider:                      PropTypes.bool,
};

VideoRecommendationsSimilarVideos.defaultProps = {
	displayTooFewItemsTile: true,
	orientationIsVertical:  true,
	perfectScrollbarOn:     true,
	slider:                 false,
};

export default withVideoRecommendationsByActorIdOrAlbumId(withVideoRecommendationsFromVideoStation(VideoRecommendationsSimilarVideos), false);
